import { EWaveLoaderVariant as EVariant } from "./wave-loader.types"

const _configMap: { [V in EVariant]: string[] } = {
    [EVariant.DarkBlue]: ["#4c4fc0", "#4446c9", "#3737d3", "#2426c6", "#1316b7"],
    [EVariant.LightBlue]: ["#9598d9", "#8f90e0", "#898ae0", "#7f80dc", "#7375d3"],
    [EVariant.WhiteBlue]: ["#ffffff", "#e5e8fb", "#ccd2f6", "#b3bcf1", "#9aa6ec"]
}

function getWaveLoaderAnimationClasses(
    identifier: string,
    loaderScheme: EVariant,
    animationName: string = "waveLoaderBounce"
): string {
    return `
        .${identifier} { animation: ${animationName} 1s ease-in-out infinite; }

        .${identifier}:first-of-type { animation-delay: 0s; fill: ${_configMap[loaderScheme][0]}; }
        .${identifier}:nth-child(3) { animation-delay: 0.1s; fill: ${_configMap[loaderScheme][1]}; }
        .${identifier}:nth-child(4) { animation-delay: 0.2s; fill: ${_configMap[loaderScheme][2]}; }
        .${identifier}:nth-child(5) { animation-delay: 0.3s; fill: ${_configMap[loaderScheme][3]}; }
        .${identifier}:nth-child(6) { animation-delay: 0.4s; fill: ${_configMap[loaderScheme][4]}; }
    
        @keyframes ${animationName} {
           0%, 100% { transform: translateY(0); }
           50% { transform: translateY(-5px); }
        }
    `
}

const config = { getWaveLoaderAnimationClasses }

export { config as waveLoaderConfig }
